import { ConfigService } from '@/configuration/services/configService';
import type { IConfig } from '@/configuration/models/IConfig';

/**
 * Базовый адрес админки (ControlPanel) без хвостового слэша: по умолчанию root-relative (Front и админка
 * на одном домене), в dev — абсолютный из конфига.
 */
export const controlPanelBaseUrl = (config: IConfig = ConfigService.get()): string =>
    (config.application.controlPanelUrl ?? '/controlpanel').replace(/\/+$/, '');

/** Страница админки по пути относительно её корня (`diagnostics/processes/general`). */
export const controlPanelUrl = (path: string): string => `${controlPanelBaseUrl()}/${path.replace(/^\/+/, '')}`;

/** Журнал ошибок админки с фильтром по коду обращения; адрес разбирает `parseErrorsUrlFilter` админки. */
export const controlPanelErrorsJournalUrl = (traceId: string): string =>
    controlPanelUrl(`logviewer?${new URLSearchParams({ traceId })}#errors`);
